import { AxiosRequestConfig } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';
import GetAffiliateRevenuePercentageResponse from '../Responses/AffiliateRevenuePercentageResponse';
import GetPaginatedResponse from '../Responses/PaginatedResponse';

export enum AffiliateRevenuePercentageOwner {
    Admin = 'admin',
    Affiliate = 'affiliate',
}

class AffiliateRevenuePercentagesApi extends AbstractCRMApi {
    public endpoint: string = 'affiliate_revenue_percentage';

    public async getPercentagePerLottery(
        ownerId: number,
        ownerType: AffiliateRevenuePercentageOwner,
        page: number = 1,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<GetAffiliateRevenuePercentageResponse>> {
        const params = { ...config?.params, page };

        return (await this.get(`/${ownerType}/${ownerId}`, { ...config, params })).data;
    }

    public async updateOrCreate(
        ownerId: number,
        ownerType: AffiliateRevenuePercentageOwner,
        lotteryId: number,
        percentage: number
    ): Promise<boolean> {
        return (await this.patch(`/${ownerType}/${ownerId}/${lotteryId}`, { percentage })).data;
    }

    public async remove(
        ownerId: number,
        ownerType: AffiliateRevenuePercentageOwner,
        lotteryId: number
    ): Promise<boolean> {
        return (await this.delete(`/${ownerType}/${ownerId}/${lotteryId}`)).data;
    }
}

export default new AffiliateRevenuePercentagesApi();
